import { render, staticRenderFns } from "./ListDaibunrui.vue?vue&type=template&id=5806dd71&"
import script from "./ListDaibunrui.vue?vue&type=script&lang=ts&"
export * from "./ListDaibunrui.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports